<template>
    <div class="box box--1-4 zq-loyalty-bonus">
        <h2 class="box__title" v-translate>Loyalty Bonus</h2>
        <div class="box__content" v-if="loading">
            <div class="loader__overlay"><div class="loader" v-translate>Loading loyalty bonus</div></div>
        </div>
        <div class="box__content" v-if="!loading">
            <div class="zq-loyalty-bonus__bonus zq-loyalty-bonus__bonus--pending">
                <span v-translate>Pending bonus</span>
                <strong><money-format :value="bonus.pending"></money-format></strong>
                <p v-translate>Pending bonus will be added to your total bonus after 21 days of purchase (because of user
                    cancellation period).</p>
            </div>
            <div class="zq-loyalty-bonus__bonus">
                <span v-translate>Total bonus received</span>
                <strong><money-format :value="bonus.total_bonus"></money-format></strong>
            </div>
            <div class="zq-loyalty-bonus__bonus">
                <span v-translate>Current Lifetime bonus</span>
                <strong>{{bonus.lifetime_bonus}}%</strong>
            </div>
        </div>
    </div>
</template>
<script>
    import MoneyFormat from '@/components/MoneyFormat.vue'
    import axios from 'axios';

    export default {
        name: 'loyalty-bonus',
        components: {MoneyFormat},
        data() {
            return {
                'loading': true,
                'bonus': {
                }
            }
        },
        methods: {
            fetchData: async function() {
                let loyalty_url = process.env.VUE_APP_ZEEQUEST_URL + 'api/bbo/loyalty-bonus/';
                this.bonus = (await axios.get(loyalty_url)).data
                this.loading = false;
            }
        },
        created: function () {
            this.fetchData()
            let that = this;
            this.interval = setInterval(function () {
                that.fetchData()
            }, 60000)
        },
        beforeDestroy() {
            clearInterval(this.interval)
        }
    }
</script>